/**
 * Per-person shell preferences kept in this browser only: the walkthrough "seen" flag, the "(i) icons" switch
 * and the collapsed menu. Keyed by the signed-in user's id so two people on one machine do not share them.
 * Every access is guarded: a private window or blocked site data throws, and the shell must work anyway.
 */
export type Pref = 'guide.seen' | 'help.icons' | 'nav.collapsed';

const key = (pref: Pref, userId: string) => `ops.${pref}.${userId}`;

export function readPref(pref: Pref, userId: string): string | null {
  try {
    return localStorage.getItem(key(pref, userId));
  } catch {
    return null;
  }
}

export function writePref(pref: Pref, userId: string, value: string): void {
  try {
    localStorage.setItem(key(pref, userId), value);
  } catch {
    /* storage unavailable: the choice still holds for this visit (it is also kept in component state) */
  }
}
